module.exports = __webpack_public_path__ + "static/media/screen2.9603b033.gif";